import type { IdentityContext } from "@utils/store/user/useUser";

interface PickChooseIdentityOpts {
  currentChooseIdentity?: IdentityContext | null;
  defaultContextId?: number | string | null;
  /** OA 入口帳戶檢查（F2/F3）算出的偏好身分：has_account 時對應入口瓦斯行的 context_id，一次性套用。 */
  preferredContextId?: number | string | null;
}

/**
 * 從 /customer/contexts 回傳的身分清單挑出要選用的身分。
 *
 * 選擇順位：1. OA 入口偏好身分（preferredContextId） 2. 沿用目前已選身分
 * 3. API 預設 default_context_id 4. 清單第一筆。
 * preferredContextId 若不在清單中（資料尚未同步等情況）則忽略，回退到原優先序。
 *
 * 重點：contexts API 不含 choose_address / address 兩欄（那是前端 bootstrap 後同步進去的）。
 * 若挑中的身分與目前相同，必須「保留」先前已同步的送達地址，否則重新載入 contexts
 * 會把使用者選的地址清掉，導致下游（如 Kiosk 加購、首頁地址顯示）取不到 customer_address_id。
 */
export function pickChooseIdentity(contexts: IdentityContext[], opts: PickChooseIdentityOpts): IdentityContext | null {
  if (!contexts?.length) return null;
  const { currentChooseIdentity, defaultContextId, preferredContextId } = opts;

  const preferredIdentity =
    preferredContextId != null ? contexts.find((c) => String(c.context_id) === String(preferredContextId)) : undefined;
  const savedIdentity = contexts.find((c) => c.context_id === currentChooseIdentity?.context_id);
  const defaultIdentity = contexts.find((c) => c.context_id === defaultContextId);
  const chosen = preferredIdentity || savedIdentity || defaultIdentity || contexts[0];

  if (currentChooseIdentity && currentChooseIdentity.context_id === chosen.context_id) {
    return { ...chosen, address: currentChooseIdentity.address, choose_address: currentChooseIdentity.choose_address };
  }
  return chosen;
}
